import { InfoIcon } from '@/assets'
import { Container, Typography } from '@cleartrip/ct-design-components'
import { ReactNode } from 'react'
interface toastProps {
  isVisible: boolean
  message?: string
  bottomPos?: string
  showIcon?: boolean
  containerClass?: string
  icon?: ReactNode
  showSuffixText?: boolean
  suffixText?: string
  onSuffixTextClick?: () => void
}
function Toast(props: toastProps) {
  const {
    isVisible,
    message,
    bottomPos = '40px',
    showIcon = true,
    containerClass = 'br-8 py-3 px-3 mx-6 r-0 l-0 p-fixed',
    icon = <InfoIcon fill='#fff' />,
    showSuffixText = false,
    suffixText = '',
    onSuffixTextClick = () => {},
  } = props

  return (
    <>
      {isVisible ? (
        <Container
          backgroundColor='#1A1A1A'
          style={{ zIndex: 10000, bottom: bottomPos, width: 'fit-content', margin: 'auto' }}
          className={containerClass}
        >
          <Container className='flex flex-middle' style={{ gap: '8px' }}>
            {showIcon && icon}
            <Typography variant='B3' color='neutral'>
              {message}
            </Typography>
            {showSuffixText && (
              <>
                <Container className = "mx-2" border='1px solid #808080' height='24px' width='0.5px' />
                <Typography variant='B3' color='neutral' onClick={onSuffixTextClick}>
                  {suffixText}
                </Typography>
              </>
            )}
          </Container>
        </Container>
      ) : null}
    </>
  )
}

export default Toast
